import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import Track from 'track/Track.js';

const baseResolution = Track.baseResolution;

class TrackLengthComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    getOptions() {
        let value = this.value * 2;
        let subtrack = 4 * this.props.resolution.resolution / 16;
        let options = [];
        while (value > 1) {
            options.push({
                label: value,
                value: value
            });
            
            value -= 4;
        }
        return options;
    }

    getOptionFromValue(value) {
        let options = this.getOptions();
        for (var i=0; i < options.length; i++) {
            if (options[i].value == value) {
                return options[i];
            }
        }
        return null;
    }

    get value() {
        return this.props.track.pattern.length(this.props.resolution);
    }

    onChangeLength(len, e) {
        len = baseResolution.transformStepAtResolution2(len, this.props.resolution);
        this.props.track.pattern.changeLength(len);
        this.props.track.updateSteps();
        this.setState(this.state);
    }

    render() {
        return (
            <div className="track-length-container">
              <div className="length-label">LENGTH</div>
              <Dropdown
                className='osc-type-dropdown'
                controlClassName='osc-type-control-dropdown'
                arrowClassName='osc-type-arrow-dropdown'
                options={this.getOptions()}
                onChange={(o, e) => this.onChangeLength(o.value, e)}
                value={this.getOptionFromValue(this.value)}
                placeholder="Length" />
            </div>
        );
    }
}

export default TrackLengthComponent;
